let WebIM = require("../../utils/IM/WebIM.js")["default"];

let msgType = require("./msgtype.js");
let groupName

function getMsgData(sendableMsg, type) {
	if (type == msgType.TEXT) {
		// sendableMsg.value.replace(/\n/gm, "")
		// return WebIM.parseEmoji(sendableMsg.value);
		// ////console.log('sendableMsg.value>>>>>>>>>', sendableMsg.value)
		// return sendableMsg.value
		return WebIM.parseEmoji(sendableMsg.value)
	} else if (type == msgType.EMOJI) {
		return sendableMsg.value;
	} else if (
		type == msgType.IMAGE ||
		type == msgType.VIDEO ||
		type == msgType.AUDIO
	) {
		return sendableMsg.body.body.url;
	} else if (type == msgType.FILE) {
		return sendableMsg.body.body.url;
	} else if (type == msgType.CUSTOM) {
		if (sendableMsg.body.customEvent == 'audio') {
			return JSON.parse(sendableMsg.body.customExts.content).url
		}

		if (sendableMsg.body.customEvent == 'goods') {
			return sendableMsg.body.goods
		}
		return sendableMsg.body.customExts.content

	}

	return "";
}

function getMsgLength(sendableMsg, type) {
	if (type == msgType.CUSTOM) {
		if (sendableMsg.body.customEvent == 'audio') {
			return JSON.parse(sendableMsg.body.customExts.content).length
		}
		return ''

	}

	return "";
}

function readJoinedGroupName() {
	const joinedGroupList = uni.getStorageSync('listGroup')
	const groupList = joinedGroupList?.data || joinedGroupList || []
	let groupName2 = {};
	groupList.forEach((item) => {
		groupName2[item.groupid] = item.groupname;
	});
	groupName = groupName2
}
module.exports = function(sendableMsg, type, myName) {
	// ////console.log(sendableMsg, 'sendableMsg')
	//   var time = WebIM.time();
	readJoinedGroupName()
	var renderableMsg = {
		info: {
			from: sendableMsg.body.from,
			to: sendableMsg.body.to
		},
		username: sendableMsg.body.from == myName ?
			sendableMsg.body.to : sendableMsg.body.from,
		yourname: sendableMsg.body.from,
		msg: {
			type: type,
			url: sendableMsg.body.url ? sendableMsg.body.url : "",
			data: getMsgData(sendableMsg, type),
			length: getMsgLength(sendableMsg, type),
			ext: sendableMsg.body.ext,
			customEvent: sendableMsg.body.customEvent
		},
		style: sendableMsg.body.from == myName ? "self" : "",
		time: sendableMsg.time || Date.now(),
		mid: sendableMsg.type + sendableMsg.id,
		id: sendableMsg.id,
		chatType: sendableMsg.body.chatType
	};
	if (renderableMsg.chatType == 'groupchat' || renderableMsg.chatType == 'groupChat') {
		// ////console.log('groupName>>>>>>>>>>>>', groupName)
		renderableMsg.groupName = groupName[sendableMsg.body.to]
	}

	if (type == msgType.IMAGE) {
		renderableMsg.msg.size = {
			width: sendableMsg.body.body.size.width,
			height: sendableMsg.body.body.size.height
		};
	} else if (type == msgType.AUDIO) {
		renderableMsg.msg.length = sendableMsg.body.length;
	} else if (type == msgType.FILE) {
		renderableMsg.msg.url = sendableMsg?.body?.body.url || "";
		renderableMsg.msg.filename = sendableMsg?.body?.body.filename || "";
		renderableMsg.msg.size = sendableMsg?.body?.body.file_length || 0;
	}

	return renderableMsg;

};